import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Link } from 'gatsby';
import Logo from 'images/svg/logoFooter.svg';
import Button from 'components/Button';
import SocialMedia from 'components/SocialMedia';
import Copyright from 'components/Copyright';

const fadeIn = keyframes`
  from {
   opacity: 0;
  }
  
  to {
  opacity: 1;
  }
  `;

const MobileMenuBg = styled.div`
  height: 2rem;
  width: 2rem;
  position: fixed;
  border-radius: 50%;
  top: 2.6rem;
  right: 2.6rem;
  z-index: 101;
  transition: transform 0.4s cubic-bezier(0.86, 0, 0.07, 1);

  ${({ isMenuOpen }) =>
    isMenuOpen &&
    css`
      background: ${({ theme }) => theme.palette.blackLighten15};
      transform: scale(150);
    `}
`;

const Modal = styled.div`
  width: 100%;
  position: fixed;
  z-index: 102;
  top: 0;
  left: 0;
  bottom: 0;
  padding: 2.4rem;
  animation: ${fadeIn} 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
`;

const LogoWrapper = styled(Link)`
  width: max-content;
  align-self: flex-start;
`;

const LogoBw = styled(Logo)`
  height: 2rem;
  width: 10.8rem;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`;

const MobileNav = styled.div`
  display: grid;
  grid-gap: 3.2rem;
  justify-content: center;
  justify-items: center;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.palette.whiteBase};
  text-decoration: none;
  font-size: 2rem;
  line-height: 1.6;
  letter-spacing: -0.02em;
  width: max-content;
`;

const FooterCtaContainer = styled.div`
  width: 100%;
  text-align: center;
`;

const StyledButton = styled(Button)`
  margin-bottom: 3.2rem;
`;

const StyledSocialMedia = styled(SocialMedia)`
  margin: 0 auto 2.4rem;
`;

const MobileMenu = ({ navigation, isMenuOpen, toggleMobileMenu }) => {
  const toggleModal = (toLocation) => {
    // eslint-disable-next-line no-restricted-globals, no-undef
    if (toLocation === location.pathname) {
      toggleMobileMenu();
    }
  };
  return (
    <>
      <MobileMenuBg isMenuOpen={isMenuOpen} />
      {isMenuOpen && (
        <Modal>
          <Flex>
            <LogoWrapper to="/" onClick={() => toggleModal('/')}>
              <LogoBw />
            </LogoWrapper>
            <MobileNav>
              {navigation.map(({ link }) => (
                <StyledLink key={link.to} to={link.to} onClick={() => toggleModal(link.to)}>
                  {link.name}
                </StyledLink>
              ))}
            </MobileNav>
            <FooterCtaContainer>
              <StyledButton>REQUEST A QUOTE</StyledButton>
              <StyledSocialMedia />
              <Copyright />
            </FooterCtaContainer>
          </Flex>
        </Modal>
      )}
    </>
  );
};

export default MobileMenu;
